import template from './paylocity-employee-mapping.html';
import controller from './paylocity-employee-mapping.controller';

let paylocityEmployeeMappingComponent = {
  restrict: 'E',
  template,
  controller
};

export default paylocityEmployeeMappingComponent;



// WEBPACK FOOTER //
// ./client/pages/admin/integrations/paylocity/capabilities/employee-mapping/paylocity-employee-mapping.component.js